import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { TeamRolesApi } from '@/lib/api/team-roles';
import type { TeamRole } from '@/lib/api/types/teamRoles';
import { capacityQueryKeys } from '@/lib/query-keys/capacity';
import { sortNamesAlphabetically } from '@/lib/utils/common/sorting';

export const getTeamRolesQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.teamRoles.all(),
    queryFn: async () => {
      return await TeamRolesApi.getTeamRoles();
    },
    select: sortNamesAlphabetically,
  };
};

export const useTeamRolesQuery = (options: Partial<UseQueryOptions<TeamRole[]>> = {}) => {
  return useQuery({ ...getTeamRolesQueryOptions(), ...options });
};
